export const bankColors = {
  'Banco Santander': '#6185DB',
  'Banco de Chile': '#13CE66',
  'Banco Itaú': '#FF9E2C',
  BCI: '#F03738',
}
